import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./utils/routes";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import Intro from "./components/Intro";
import { useEffect, useState } from "react";
import { setmoodBoardUser } from "./redux/slicers/moodBoardUser";

export default function App() {
  // console.log("BACKENDURL = ", process.env.REACT_APP_BACK_URL);
  const dispatch = useDispatch();
  const [isIntro, setIsIntro] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsIntro(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const company = params.get("company");
      const location = params.get("location");
      const number = params.get("number");
      const directionParam = params.get("direction");

      if (company || location || number || directionParam) {
        let direction = "";
        if (directionParam) {
          try {
            direction = JSON.parse(directionParam);
          } catch (e) {
            direction = directionParam;
          }
        }
        const payload = {
          company: company || "",
          location: location || "",
          number: number || "",
          direction: direction || "",
        };
        dispatch(setmoodBoardUser(payload));
        localStorage.setItem("moodboard_user_data", JSON.stringify(payload));
      } else {
        const stored = localStorage.getItem("moodboard_user_data");
        if (stored) {
          dispatch(setmoodBoardUser(JSON.parse(stored)));
        }
      }
    } catch (e) {
      console.error("Error loading stored moodboard user:", e);
    }

    const handleMessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        if (message.type === "set_moodboard_user_data") {
          dispatch(setmoodBoardUser(message.payload));
          localStorage.setItem(
            "moodboard_user_data",
            JSON.stringify(message.payload),
          );
        }
      } catch (e) {
        console.error("Error: ", e);
      }
    };

    window.addEventListener("message", handleMessage);
    document.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      document.removeEventListener("message", handleMessage);
    };
  }, [dispatch]);

  if (isIntro) {
    return <Intro />;
  }
  // redeployed

  return (
    <>
      <ToastContainer />
      <AppRoutes />
    </>
  );
}
